import React from 'react';
import {useForestCompositionState, useForestCompositionDispatch} from './ForestCompositionContext';
import Select from 'react-select';

const ForestCompositionEditor = ({allTrees}) => {
	const {treeIds,proportions,smartBalance} = useForestCompositionState();
	const dispatch = useForestCompositionDispatch();
	const state = useForestCompositionState();
	console.log('state',state);
	const defaultOption = {label:'Select a tree species', value:''};
	const selectedOption = defaultOption;

	const total = proportions.reduce((sum,p) => sum + p, 0);

	let treeIdSelected = treeIds.reduce((dict,id) => {
		dict[id] = true;
		return dict;
	},{});

	let options = 
		allTrees
		.filter(t => !!t && !!t.name) //Since allTrees was implemented upstream as a dictionary... there may be gaps when read as an array (deletions).
		.filter(t => !treeIdSelected[t.id])
		.map(t => ({
			value: t.id,
			label: `${t.name} (${(t.description || "").trim()})`
		}));

	return (
		<table className="table table-bordered">
			{treeIds.length > 0 
			?
				<thead>
					<tr>
						<th>Tree species</th>
						<th>Proportion of forest</th>
						<th>&nbsp;</th>
					</tr>
				</thead>
			: <></>
			}

			<tbody>
				{treeIds.length === 0 
				? <tr>
						<td className="text-center">
							Select a tree species to get started.
							{' '}
							<span role="img" aria-label="tree">
								🌲
							</span>
						</td>
				</tr>
				: treeIds.map((treeId,treeIndex) => (
					<tr key={treeId}>
						<td>{(allTrees[treeId-1] || {name:treeId-1}).name}</td>
						<td style={{width:'12em'}}> 
							<div className="input-group">
								<input type="number"
									min="0" max="100"
									className="form-control text-center"
									onChange={e => dispatch({type:'setTreeProportion',atIndex:treeIndex, proportion: parseInt(e.target.value)})}
									value={proportions[treeIndex]}/>
								<div className="input-group-append">
									<span className="input-group-text">%</span>
								</div>
							</div>
						</td>
						<td style={{width:'10em'}} className="text-center">
							{/*
								<div className="btn-group mr-3">
									<button className="btn btn-outline-secondary"
										disabled={treeIndex === 0}
										onClick={() => dispatch({type:'moveTree',fromIndex: treeIndex, toIndex: treeIndex-1})}>
											<span role="img" aria-label="up">
												⬆️️
											</span>
									</button>
									<button className="btn btn-outline-secondary"
										disabled={treeIndex === treeIds.length-1}
										onClick={() => dispatch({type:'moveTree',fromIndex: treeIndex, toIndex: treeIndex+1})}>
											<span role="img" aria-label="down">
												⬇️
											</span>
									</button>
								</div>
							*/}
							<button className="btn btn-block btn-outline-danger"
								onClick={() => dispatch({type:'removeTree',atIndex: treeIndex})}>
									Remove
							</button>
						</td>
					</tr>
				))}
		</tbody>
		<tfoot>
			<tr>
				<td>
					<Select
						autoFocus={true}
						options={options}
						onChange={o => dispatch({type:'addTree',treeId: parseInt(o.value) })}
						value={selectedOption}
						defaultValue={defaultOption}>
					</Select>
				</td>
				{treeIds.length === 0 
				? <></>
				: <>
					<td>
						<div className="input-group">
							<input type="number"
								min="0" max="100"
								className="form-control text-center"
								disabled={true}
								value={total}/>
							<div className="input-group-append">
								<span className="input-group-text">%</span>
							</div>
						</div>
					</td>
					<td>
						{total === 100 
						? 
							<div className="form-check mt-1">
								<input className="form-check-input"
									type="checkbox"
									id="smartBalance"
									checked={smartBalance}
									onChange={e => dispatch({type:'setSmartBalance', smartBalance: e.target.checked })} />

								<label className="form-check-label"
									htmlFor="smartBalance">
									Keep balanced
								</label>
							</div>
						: 
							<button
								className="btn btn-block btn-outline-secondary"
								disabled={treeIds.length === 0 || total === 100}
								onClick={() => dispatch({type:'balance'})}>
									Balance
							</button>
						}
						{/*
						<button
							className="btn btn-block btn-outline-danger"
							disabled={treeIds.length === 0}
							onClick={() => dispatch({type:'removeAll'})}>
								Remove all
						</button>
						*/}
					</td>
				</>}
			</tr>
		</tfoot>
	</table>);
}

export default ForestCompositionEditor;